import firebase from '../plugins/firebase'

const firestore = firebase.firestore()

export default firestore;